import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import {
  BannerEntity,
  CreateBannerRequest,
  UpdateBannerRequest,
} from "./types";

import { Data } from "@/shared/types.ts";
import api from "@/shared/api";

export function useBanners() {
  return useQuery<Data<BannerEntity[]>>({
    queryKey: ["banners"],
    queryFn: () => api.get<Data<BannerEntity[]>>("/api/v1/banners").json(),
    initialData: { data: [], code: 0, description: "", success: true },
  });
}

export function useCreateBanner() {
  const queryClient = useQueryClient();

  return useMutation<Data<BannerEntity>, Error, CreateBannerRequest>({
    mutationFn: (data) => api.post("/api/v1/banners", { json: data }).json(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["banners"] });
    },
  });
}

export function useUpdateBanner() {
  const queryClient = useQueryClient();

  return useMutation<Data<BannerEntity>, Error, UpdateBannerRequest>({
    mutationFn: (data) => api.put("/api/v1/banners", { json: data }).json(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["banners"] });
    },
  });
}

export function useDeleteBanner() {
  const queryClient = useQueryClient();

  return useMutation<Data<BannerEntity>, Error, { id: number }>({
    mutationFn: ({ id }) => api.delete(`/api/v1/banners/${id}`).json(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["banners"] });
    },
  });
}
